import { Routes } from '@angular/router';
import { DefaultLayoutComponent, EmailLayoutComponent } from './layout';
import { AuthGuard } from '@infra-adapters/guards/auth.guard';
import { RoleGuard } from '@infra-adapters/guards/role.guard';
import { InvalidSessionGuard } from '@infra-adapters/guards/invalidSession.guard';
import { UserRole } from '@core-interfaces/global';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'request',
    pathMatch: 'full'
  },
  {
    path: 'apps/email',
    component: EmailLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./views/themes/apps/email/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      // {
      //   path: 'dashboard',
      //   loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      // },
      // Rutas de KDM
      {
        path: 'municipality',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/municipality/routes').then((m) => m.routes)
      },
      {
        path: 'commune',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/commune/routes').then((m) => m.routes)
      },
      {
        path: 'sector',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/sector/routes').then((m) => m.routes)
      },
      {
        path: 'schedule',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/schedule/routes').then((m) => m.routes)
      },
      // Puntos de reciclaje
      {
        path: 'recycling-element-type',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/recycling-element-type/routes').then((m) => m.routes)
      },
      {
        path: 'recycling-point',
        loadChildren: () => import('./views/recycling-point/routes').then((m) => m.routes)
      },
      // Administracion de usuarios
      {
        path: 'user',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/user/routes').then((m) => m.routes)
      },
      {
        path: 'admin-user',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/admin-user/routes').then((m) => m.routes)
      },
      // Notification Campaigns
      {
        path: 'campaign',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/campaign/routes').then((m) => m.routes)
      },
      // Request Management
      {
        path: 'request',
        loadChildren: () => import('./views/request/routes').then((m) => m.routes)
      },
      // App Settings
      {
        path: 'app-settings',
        canActivate: [RoleGuard],
        loadComponent: () => import('./views/app-settings/app-settings.component').then(m => m.AppSettingsComponent),
        data: {
          title: 'Configuración Global',
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        }
      },
      // Truck Settings
      {
        path: 'truck-settings',
        canActivate: [RoleGuard],
        loadComponent: () => import('./views/truck-settings/truck-settings.component').then(m => m.TruckSettingsComponent),
        data: {
          title: 'Configuración de Camiones',
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        }
      },
      // Visual Settings (PWA layout / header por comuna)
      {
        path: 'visual-settings',
        canActivate: [RoleGuard],
        loadComponent: () =>
          import('./views/visual-settings/visual-settings.component').then(
            (m) => m.VisualSettingsComponent
          ),
        data: {
          title: 'Configuración visual',
          roles: [UserRole.Administrator, UserRole.SuperAdministrator],
        },
      },
      // News Management
      {
        path: 'news',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/news/routes').then((m) => m.routes)
      },
      // Commune Informative Messages
      {
        path: 'commune-informative-message',
        canActivate: [RoleGuard],
        data: {
          roles: [UserRole.Administrator, UserRole.SuperAdministrator]
        },
        loadChildren: () => import('./views/commune-informative-message/routes').then((m) => m.routes)
      }
      // {
      //   path: 'role',
      //   loadChildren: () => import('./views/role/routes').then((m) => m.routes)
      // },
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'recover-password',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/pages/recover-password/recover-password.component').then(m => m.RecoverPasswordComponent),
    data: {
      title: 'Recover Password'
    }
  },
  {
    path: 'new-password/:token',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/pages/new-password/new-password.component').then(m => m.NewPasswordComponent),
    data: {
      title: 'New Password',
      allowTokenAccess: true
    }
  },
  {
    path: 'register',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  { path: '**', redirectTo: 'login' }
];
